class FilterList {
	constructor() {
		this.groups = [];
		this.saved = (typeof filters !== 'undefined' && filters) ? filters : [];

		this.popup = Dialog.Popup(
			UI.div(null, [
				UI.htm('h4', null, 'Filters'),
				this.groupsElem = UI.div(),
				this.clearBtn = UI.btn('', _('CLEAR ALL'), {
					'click': this.clear.bind(this)
				})
			]),
			'below-end'
		).sticky();
		
		// this.button = ge('filter-button');
		// onEv(this.button, 'click', () => this.popup.handle(this.button));
		this.button = UI.priIconBtn('filter', 18, {'click': _ => this.popup.handle(this.button)});
		onEv(document, 'filterSelected', () => this.saved = false);
	}
	
	addGroup(title, name, controller) {
		let group = new FilterGroup(this, title, name, controller);
		this.groups.push(group);
		this.groupsElem.appendChild(group.elem);
	}

	clear() {
		this.groups.forEach(g => g.clear());
		document.dispatchEvent(new Event('filterSelected'));
	}

	params(params) {
		params = params?? new URLSearchParams();
		for (let k in this.saved) {
			this.saved[k].split(',').map(v => {params.append(k, v)});
		}
		this.groups.map(grp => {grp.params(params)});
	}

	getGroup(group) {
		return this.groups.filter(f => f.name == group).map(g => {
			if (!g.initialized && this.saved && this.saved[g.name]) return this.saved[g.name];
			return g.toArray.join(',');
		});
	}

	get toJSON() {
		if (this.saved) return JSON.stringify(this.saved);
		let r = {};
		this.groups.filter(g => g.active).map(g => {r[g.name] = g.toArray;});
		return JSON.stringify(r);
	}

	get toString() {
		if (this.saved) return JSON.stringify(this.saved);
		let res = '';
		for (let g of this.groups) {
			res += g.toString;
		}
		return res;
	}
}
